import { AxiosError } from 'axios';

export const createTransformErrorResponseInterceptor = () => {
    const transformResponseToJSON = (data) => {
        if (data instanceof ArrayBuffer) {
            return JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
        }

        if (typeof data === 'string') {
            return JSON.parse(data);
        }

        throw new Error('Could not infer type of data and thus transform it to JSON.');
    };

    return {
        errorHandler: (error) => {
            if (!(error instanceof AxiosError)) {
                return Promise.reject(error);
            }

            const { config, response } = error;

            if (
                !config?.responseType ||
                config.responseType === 'json' ||
                config.transformErrorResponse === false
            ) {
                return Promise.reject(error);
            }

            const responseType = response.headers['content-type'];

            if (responseType === 'application/json') {
                return Promise.reject(
                    AxiosError.from(error, undefined, undefined, undefined, {
                        ...response,
                        data: transformResponseToJSON(response.data),
                    })
                );
            }

            return Promise.reject(error);
        },
    };
};
